import React, { FC, useContext } from 'react';

import { LocalizationContext } from '../../../../localization';
import s from '../ApplicationManager.module.scss';

const ApplicationTooltip: FC = () => {
  const { t } = useContext(LocalizationContext);
  return (
    <div className={s['properties']}>
      <div className={s['property']}>
        <div>{t('application.image.minRes')}</div>
        <div className={s.value}>256x384</div>
      </div>
      <div className={s['property']}>
        <div>{t('application.image.size')}</div>
        <div className={s.value}>600x900</div>
      </div>
      <div className={s['property']}>
        <div>{t('application.image.sides')}</div>
        <div className={s.value}>2:3</div>
      </div>
      <div className={s['property']}>
        <div>{t('application.image.maxSize')}</div>
        <div className={s.value}>250 kb</div>
      </div>
      <div className={s['property']}>
        <div>{t('application.image.format')}</div>
        <div className={s.value}>.jpg, .png</div>
      </div>
    </div>
  );
};

export default ApplicationTooltip;
